import styled from 'styled-components';

export const StyledButton = styled.button <{ clickable: boolean }>`
  padding: 36px 0;
  border-top: 0;
  border-left: 0;
  border-right: 0;
  border-bottom: 1px solid ${({ theme }) => theme?.colors.gray3};
  width: 100%;
  text-align: inherit;
  background-color: inherit;
  outline: none;

  ${({ clickable, theme }) => clickable && `
    cursor: pointer;
    color: ${theme.colors.blue6};
    &:focus {
      color: ${theme.colors.blue5};
    }
    &:hover {
      color: ${theme.colors.blue5};
    }
    &:active {
      color: ${theme.colors.blue10};
    }
  `}

  &:disabled {
    color: inherit;
  }
`;
